import { Field, Text } from '@noorden-insurtech/alba-design-system';
import { formatCurrency } from '@/shared/utils/currencyFormatter';
import {
  formatRiskCapitalInput,
  RISK_STEP_MAX_LIVES_VALUE,
  sanitizeLivesInput,
} from '../utils/step-helpers.util';

type Props = {
  // Sócios/Diretores
  sdQuantidadeDeVidas: string;
  onSdQuantidadeDeVidasChange: (value: string) => void;
  errorSdQuantidadeDeVidas?: string;

  sdCapitalIndividual: string;
  onSdCapitalIndividualChange: (value: string) => void;
  errorSdCapitalIndividual?: string;
  /** Faixa permitida já formatada — cada banda tem a sua, resolvida no step. */
  sdCapitalIndividualHint: string;

  capitalSeguradoSd: number;

  // Colaboradores
  colQuantidadeDeVidas: string;
  onColQuantidadeDeVidasChange: (value: string) => void;
  errorColQuantidadeDeVidas?: string;

  colCapitalIndividual: string;
  onColCapitalIndividualChange: (value: string) => void;
  errorColCapitalIndividual?: string;
  colCapitalIndividualHint: string;

  capitalSeguradoCol: number;

  disabled?: boolean;
};

export function EscalonadoRiskFields({
  sdQuantidadeDeVidas,
  onSdQuantidadeDeVidasChange,
  errorSdQuantidadeDeVidas,
  sdCapitalIndividual,
  onSdCapitalIndividualChange,
  errorSdCapitalIndividual,
  sdCapitalIndividualHint,
  capitalSeguradoSd,
  colQuantidadeDeVidas,
  onColQuantidadeDeVidasChange,
  errorColQuantidadeDeVidas,
  colCapitalIndividual,
  onColCapitalIndividualChange,
  errorColCapitalIndividual,
  colCapitalIndividualHint,
  capitalSeguradoCol,
  disabled,
}: Props) {
  return (
    <div className='flex flex-col gap-8'>
      {/* Sócios/Diretores */}
      <div className='flex flex-col gap-4'>
        <Text className='text-base text-alba-black-500'>Sócios/Diretores</Text>

        <div className='grid grid-cols-1 lg:grid-cols-3 gap-10'>
          <Field.Root invalid={!!errorSdQuantidadeDeVidas}>
            <Field.Label className='text-sm font-bold text-alba-black-500'>
              Quantidade de Vidas{' '}
              <span className='text-alba-error-red-500'>*</span>
            </Field.Label>
            <Field.Input
              type='number'
              min={1}
              max={RISK_STEP_MAX_LIVES_VALUE}
              value={sdQuantidadeDeVidas}
              onChange={e =>
                onSdQuantidadeDeVidasChange(sanitizeLivesInput(e.target.value))
              }
              placeholder='Digite a quantidade'
              disabled={disabled}
            />
            {errorSdQuantidadeDeVidas && (
              <Field.ErrorText>{errorSdQuantidadeDeVidas}</Field.ErrorText>
            )}
          </Field.Root>

          <Field.Root invalid={!!errorSdCapitalIndividual}>
            <Field.Label className='text-sm font-bold text-alba-black-500'>
              Capital Individual{' '}
              <span className='text-alba-error-red-500'>*</span>
            </Field.Label>
            <Field.Input
              type='text'
              inputMode='decimal'
              value={sdCapitalIndividual}
              onChange={e =>
                onSdCapitalIndividualChange(
                  formatRiskCapitalInput(e.target.value)
                )
              }
              placeholder='R$ 0,00'
              disabled={disabled}
            />
            {errorSdCapitalIndividual ? (
              <Field.ErrorText>{errorSdCapitalIndividual}</Field.ErrorText>
            ) : (
              <Field.HelperText>{sdCapitalIndividualHint}</Field.HelperText>
            )}
          </Field.Root>

          <Field.Root>
            <Field.Label className='text-sm font-bold text-alba-black-500'>
              Capital Segurado do Grupo
            </Field.Label>
            <Field.Input
              value={
                capitalSeguradoSd > 0 ? formatCurrency(capitalSeguradoSd) : ''
              }
              readOnly
              disabled
              placeholder=''
            />
          </Field.Root>
        </div>
      </div>

      {/* Colaboradores */}
      <div className='flex flex-col gap-4'>
        <Text className='text-base text-alba-black-500'>Colaboradores</Text>

        <div className='grid grid-cols-1 lg:grid-cols-3 gap-10'>
          <Field.Root invalid={!!errorColQuantidadeDeVidas}>
            <Field.Label className='text-sm font-bold text-alba-black-500'>
              Quantidade de Vidas{' '}
              <span className='text-alba-error-red-500'>*</span>
            </Field.Label>
            <Field.Input
              type='number'
              min={1}
              max={RISK_STEP_MAX_LIVES_VALUE}
              value={colQuantidadeDeVidas}
              onChange={e =>
                onColQuantidadeDeVidasChange(sanitizeLivesInput(e.target.value))
              }
              placeholder='Digite a quantidade'
              disabled={disabled}
            />
            {errorColQuantidadeDeVidas && (
              <Field.ErrorText>{errorColQuantidadeDeVidas}</Field.ErrorText>
            )}
          </Field.Root>

          <Field.Root invalid={!!errorColCapitalIndividual}>
            <Field.Label className='text-sm font-bold text-alba-black-500'>
              Capital Individual{' '}
              <span className='text-alba-error-red-500'>*</span>
            </Field.Label>
            <Field.Input
              type='text'
              inputMode='decimal'
              value={colCapitalIndividual}
              onChange={e =>
                onColCapitalIndividualChange(
                  formatRiskCapitalInput(e.target.value)
                )
              }
              placeholder='R$ 0,00'
              disabled={disabled}
            />
            {errorColCapitalIndividual ? (
              <Field.ErrorText>{errorColCapitalIndividual}</Field.ErrorText>
            ) : (
              <Field.HelperText>{colCapitalIndividualHint}</Field.HelperText>
            )}
          </Field.Root>

          <Field.Root>
            <Field.Label className='text-sm font-bold text-alba-black-500'>
              Capital Segurado do Grupo
            </Field.Label>
            <Field.Input
              value={
                capitalSeguradoCol > 0 ? formatCurrency(capitalSeguradoCol) : ''
              }
              readOnly
              disabled
              placeholder=''
            />
          </Field.Root>
        </div>
      </div>
    </div>
  );
}
